import { Component, OnInit,Input,ViewChild } from '@angular/core';
import {TopicService} from "../../service/topic.service";
import { HttpErrorResponse } from '@angular/common/http';
@Component({
  selector: 'app-right-sidebar2',
  templateUrl: './right-sidebar2.component.html',
  styleUrls: ['./right-sidebar2.component.css'],
providers:[TopicService]
})
export class RightSidebar2Component implements OnInit {

  @Input() public user;
  popularTopiclist:any=[];
  msg="";
  Discussion="Discussion";
  constructor(private topicService:TopicService) {
    

   }

  ngOnInit() {
    
 
  }
  
}



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/home/right-sidebar2/right-sidebar2.component.ts